import { Dispatch, ReactNode, createContext, useReducer } from "react";
import { EnrollmentAction, enrollmentReducer } from "./reducer";
import { ENROLLMENT_DEFAULT_STATE, EnrollmentState } from "./state";

export const EnrollmentContext = createContext<[EnrollmentState, Dispatch<EnrollmentAction>]>([
  ENROLLMENT_DEFAULT_STATE,
  ((_: EnrollmentAction) => ENROLLMENT_DEFAULT_STATE) as Dispatch<EnrollmentAction>,
]);

export const EnrollmentStore = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(enrollmentReducer, ENROLLMENT_DEFAULT_STATE);

  return (
    <EnrollmentContext.Provider value={[state, dispatch]}>
      {children}
    </EnrollmentContext.Provider>
  );
};
